import { z } from 'zod';

/**
 * Schéma de connexion, repris de `frontend/src/features/auth/schemas.ts`.
 *
 * Pas de règle de longueur ici : des comptes créés sous une politique de mot de passe plus
 * ancienne doivent rester utilisables, et exiger un format renseignerait un attaquant sur la
 * forme des mots de passe acceptés.
 */
export const loginSchema = z.object({
  email: z
    .string()
    .min(1, "L'adresse email est obligatoire.")
    .email("L'adresse email n'est pas au bon format."),
  password: z.string().min(1, 'Le mot de passe est obligatoire.'),
});

export type LoginInput = z.infer<typeof loginSchema>;
